(function () {
    'use strict';

    angular
        .module('ib-user-tooltip-module')
        .controller('UserTooltipController', UserTooltipController);

    UserTooltipController.$inject = ['$window', '$rootScope','CommonsUserUtilsService'];
    function UserTooltipController ($window, $rootScope ,CommonsUserUtilsService) {
        const vm = this;

        vm.$onInit = activate;
        vm.isIbPlus = () => CommonsUserUtilsService.isIbPlus();

        function activate () {
        }
    }
})();